<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>

<div class="modal-body">
  <mdb-card>
    <mdb-card-body>
      <mat-tab-group #tabGroup>
        <mat-tab label="Carga de archivo">
          <mdb-card>
            <mdb-card-body>

              <div class="form-row mb-3">
                <div class="col-12">
                  <input mdbInput type="text" maxlength="100"  class="form-control" [(ngModel)]="x_informacion" placeholder="" readonly>
                </div>
              </div>

              <div class="form-row mb-3">
                <div class="col-4">Plantilla CSV:</div>
                <div class="col-8">
                  <div class="input-group-append">
                    <button mdbBtn type="button" (click)="onDescargarPlantilla()" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
                    <mdb-icon fas icon="file-csv" class="mr-1"></mdb-icon>Descargar plantilla .CSV</button>
                  </div>
                </div>
              </div>

              <div class="form-row mb-3">
                <div class="col-4">Incluye codigo de constancia:</div>
                <div class="col-8">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox"  [(ngModel)]="listaincluyecodigo">
                  </div>
                </div>
              </div>

              <div class="form-row mb-3">
                <div class="col-4">Lista de participantes:</div>
                <div class="col-8">
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" multiple id="importFileCsv" (change)="onFileCsvChange($event.target.files)">
                    <label class="custom-file-label" #labelArchivoCsv for="importFileCsv">Seleccionar archivo .CSV</label>
                  </div>
                </div>
              </div>
            </mdb-card-body>
          </mdb-card>
        </mat-tab>

        <mat-tab label="Listado de Participantes" [disabled]="semuestralista==false">
          <mdb-card>
            <mdb-card-body>
              <div class="form-row mb-3">
                <div class="col-6">Lista de <b>{{listParticipantesCsv.length}}</b> participantes a agregar:</div>
              </div>
              <div class="table-responsive">
                <table mdbTable hover="true" class="table">
                    <thead>
                      <tr>
                        <th scope="col">Nro</th>
                        <th scope="col">Nombres</th>
                        <th scope="col">Email</th>
                        <th scope="col">Nota</th>
                        <th scope="col" *ngIf="listaincluyecodigo">Codigo</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr mdbTableCol *ngFor="let listParti of listParticipantesCsv | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
                        <th>{{i + 1+10*(page-1)}}</th>
                        <th>{{listParti.nombre}}</th>
                        <td>{{listParti.correo}}</td>
                        <td>{{listParti.nota}}</td>
                        <td *ngIf="listaincluyecodigo">{{listParti.codigo}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-center">
                  <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
                    [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listParticipantesCsv.length">
                  </ngb-pagination>
                </div>
            </mdb-card-body>
          </mdb-card>
          <br>
          <div class="justify-content-center" style="text-align: center;">
            <button mdbBtn type="button" (click)="onAgregarTodosRecurIni()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="user-plus" class="mr-1"></mdb-icon>AGREGAR TODOS ({{listParticipantesCsv.length}})</button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mdb-card-body>
  </mdb-card>

</div>
